<div class="prs-notifications-menu" [class.prs-notifications-menu--open]="open">
  <button
    type="button"
    class="prs-header-help-trigger prs-notifications-menu__trigger"
    data-testing-id="header-notifications"
    (click)="toggle()"
    [attr.aria-expanded]="open"
    [attr.aria-controls]="'prs-notifications-panel'"
    [attr.aria-label]="'shell.notifications.aria' | translate: { '0': (unreadCount$ | async) || 0 }"
  >
    <span class="prs-notifications-menu__icon-wrap">
      <i class="bi bi-bell prs-header-help-trigger__icon" aria-hidden="true"></i>
      @if (unreadCount$ | async; as unread) {
        @if (unread > 0) {
          <span class="prs-notifications-menu__badge" aria-hidden="true" data-testing-id="header-notifications-badge">{{
            unread > 9 ? '9+' : unread
          }}</span>
        }
      }
    </span>
    <span class="prs-header-help-trigger__label d-none d-xl-inline">{{
      'shell.notifications.label' | translate
    }}</span>
  </button>

  <div
    *ngIf="open"
    id="prs-notifications-panel"
    class="prs-notifications-menu__panel"
    role="region"
    [attr.aria-label]="'shell.notifications.panel_aria' | translate"
    data-testing-id="header-notifications-panel"
  >
    <div class="prs-notifications-menu__head">
      <h2 class="prs-notifications-menu__title">{{ 'shell.notifications.heading' | translate }}</h2>
      @if (items$ | async; as items) {
        @if (items.length) {
          <div class="prs-notifications-menu__actions">
            @if (unreadCount$ | async; as unread) {
              @if (unread > 0) {
                <button
                  type="button"
                  class="btn btn-link btn-sm px-0 prs-notifications-menu__action"
                  data-testing-id="header-notifications-mark-all"
                  (click)="markAllRead($event)"
                >
                  {{ 'shell.notifications.mark_all_read' | translate }}
                </button>
              }
            }
            <button
              type="button"
              class="btn btn-link btn-sm px-0 prs-notifications-menu__action"
              data-testing-id="header-notifications-clear-all"
              (click)="clearAll($event)"
            >
              {{ 'shell.notifications.clear_all' | translate }}
            </button>
          </div>
        }
      }
    </div>

    @if (items$ | async; as items) {
      @if (items.length) {
        <ul class="prs-notifications-menu__list list-unstyled mb-0">
          @for (item of items; track item.id) {
            <li
              class="prs-notifications-menu__row"
              [class.prs-notifications-menu__row--unread]="!item.read"
            >
              <a
                class="prs-notifications-menu__item"
                [routerLink]="item.link"
                [attr.data-testing-id]="'header-notification-' + item.id"
                (click)="onSelect(item, $event)"
              >
                <span class="prs-notifications-menu__item-icon" aria-hidden="true">
                  <i class="bi" [ngClass]="categoryIcon(item.category)"></i>
                </span>
                <span class="prs-notifications-menu__item-copy">
                  <span class="prs-notifications-menu__item-title">{{
                    item.titleKey | translate: { '0': item.refId }
                  }}</span>
                  <span class="prs-notifications-menu__item-body">{{
                    item.bodyKey | translate: { '0': item.refId }
                  }}</span>
                </span>
              </a>
              <div class="prs-notifications-menu__meta">
                <span
                  class="prs-notifications-menu__dot"
                  [class.prs-notifications-menu__dot--hidden]="item.read"
                  aria-hidden="true"
                ></span>
                <button
                  type="button"
                  class="btn btn-link btn-sm px-0 prs-notifications-menu__read-toggle"
                  [attr.data-testing-id]="'header-notification-toggle-' + item.id"
                  [attr.aria-label]="
                    (item.read ? 'shell.notifications.mark_unread_aria' : 'shell.notifications.mark_read_aria')
                      | translate
                  "
                  (click)="toggleRead(item, $event)"
                >
                  {{
                    (item.read ? 'shell.notifications.mark_unread' : 'shell.notifications.mark_read') | translate
                  }}
                </button>
              </div>
            </li>
          }
        </ul>
      } @else {
        <p class="prs-notifications-menu__empty mb-0" data-testing-id="header-notifications-empty">
          {{ 'shell.notifications.empty' | translate }}
        </p>
      }
    }
  </div>
</div>
